import './SankeyCanvas.css';
export var canvasContainer = '_1hfx9ue0-3-12-1';